/*
  Kurumsal fatura — sepet sayfasi + sepet cekmecesi

  Plus olmayan magazada odeme adimina alan eklenemedigi icin fatura bilgisi
  sepette alinir ve CART ATTRIBUTE olarak yazilir. Shopify bunlari siparise
  kendisi tasir; fatura entegratoru siparis ozelliklerinden okur.

  SOZLESME — anahtar adlari backend tarafindan okunuyor, DEGISTIRME:
    fatura_tipi     "kurumsal"
    sirket_turu     "sahis" | CORP_VALUE (asagida). Popup'ta iki secenek var:
                    sahis sirketi (TCKN) ve sirket (Ltd., A.S. ve digerleri, VKN).
                    Eski surumden kalan limited/anonim/diger ikinci secenek
                    olarak acilir.
    firma_unvani    metin
    vergi_no        tuzelde 10 haneli VKN, sahis sirketinde 11 haneli TCKN
    vergi_dairesi   metin
    efatura_eposta  istege bagli
    tc_no           ARTIK YAZILMAZ (2026-09-23 karari). Kaydederken her zaman ""
                    gonderilir: eski surumden kalmis bir deger varsa Shopify onu
                    siler, siparise sizmaz.
  Kaldirma: tc_no dahil yedi anahtarin HEPSI "" gonderilir (Shopify bos degeri siler).

  YAPI
    <etf-corporate-invoice>  sepette gorunen dugme / ozet karti. Custom
                             element oldugu icin sepet cekmecesi ya da
                             cart-main-02 yeniden cizildiginde (innerHTML)
                             connectedCallback yeniden calisir, durum
                             kaybolmaz.
    tek popup               ilk acilista <body>'ye bir kez eklenir; cekmecenin
                             transform/overflow'u icinde kalmasin diye.
    durum                   tek ortak depo; once Liquid'in bastigi
                             data-state, sonra /cart.js ile dogrulanir.

  Metinler snippets/ga-corporate-invoice.liquid'deki
  window.etfCorporateInvoiceConfig'ten gelir.
*/
(function () {
  if (window.__etfCorporateInvoice) return;
  window.__etfCorporateInvoice = true;

  var KEYS = ['fatura_tipi', 'sirket_turu', 'firma_unvani', 'vergi_no', 'vergi_dairesi', 'tc_no', 'efatura_eposta'];
  var TYPES = ['sahis', 'tuzel'];
  /* Ikinci secenekte sirket_turu'na yazilan deger — backend ile ayni olmali. */
  var CORP_VALUE = 'tuzel';

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function str(k) {
    var c = window.etfCorporateInvoiceConfig;
    return (c && c.strings && c.strings[k]) || '';
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function digits(v) { return String(v || '').replace(/\D/g, ''); }

  /* ---------- Dogrulama ---------- */

  function isTckn(v) {
    if (!/^[1-9]\d{10}$/.test(v)) return false;
    var d = v.split('').map(Number);
    var odd = d[0] + d[2] + d[4] + d[6] + d[8];
    var even = d[1] + d[3] + d[5] + d[7];
    var c10 = (((odd * 7 - even) % 10) + 10) % 10;
    if (c10 !== d[9]) return false;
    var sum = 0;
    for (var i = 0; i < 10; i++) sum += d[i];
    return sum % 10 === d[10];
  }

  function isVkn(v) {
    if (!/^\d{10}$/.test(v)) return false;
    var d = v.split('').map(Number);
    var sum = 0;
    for (var i = 1; i <= 9; i++) {
      var t = (d[i - 1] + 10 - i) % 10;
      var r = 0;
      if (t !== 0) {
        r = (t * Math.pow(2, 10 - i)) % 9;
        if (r === 0) r = 9;
      }
      sum += r;
    }
    return (10 - (sum % 10)) % 10 === d[9];
  }

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  /* ---------- Ortak durum ---------- */

  var store = { attrs: null, verified: false, loading: null, hosts: [] };

  function pick(a) {
    var o = {};
    KEYS.forEach(function (k) { o[k] = a && a[k] != null ? String(a[k]) : ''; });
    return o;
  }

  function isSet(a) { return !!(a && a.fatura_tipi === 'kurumsal' && a.firma_unvani && a.vergi_no); }

  function setAttrs(a) {
    store.attrs = pick(a);
    store.hosts.forEach(function (h) { h.render(); });
  }

  function verify() {
    if (store.verified || store.loading) return store.loading;
    store.loading = fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { store.verified = true; setAttrs(cart.attributes || {}); })
      .catch(function () {})
      .then(function () { store.loading = null; });
    return store.loading;
  }

  function writeAttrs(attrs) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    }).then(function (cart) {
      setAttrs(cart.attributes || {});
      window.dispatchEvent(new CustomEvent('etf:corporate-invoice:change', { detail: pick(cart.attributes || {}) }));
      return cart;
    });
  }

  function emptyAttrs() {
    var o = {};
    KEYS.forEach(function (k) { o[k] = ''; });
    return o;
  }

  /* Baska bir bilesen guncel sepeti yayinlarsa (ga-cart-add.js vb.) onu kullan. */
  window.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.attributes) setAttrs(e.detail.attributes);
  });

  /* ---------- Ikonlar ---------- */

  var ICON_DOC = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/></svg>';
  var ICON_CHEVRON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';
  var ICON_CLOSE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
  var ICON_INFO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>';

  /* ---------- Popup ---------- */

  var modal = null;
  var ui = {};
  var form = {};
  var touched = {};
  var opener = null;
  var prevOverflow = '';
  var busy = false;

  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'etf-ci-modal';
    modal.hidden = true;

    var typeOpts = TYPES.map(function (t) {
      var hint = str('type_' + t + '_hint')
        ? '<span class="etf-ci-type-hint">' + esc(str('type_' + t + '_hint')) + '</span>' : '';
      return '<label class="etf-ci-type">' +
        '<input type="radio" name="etf-ci-type" value="' + t + '">' +
        '<span class="etf-ci-type-box"><span class="etf-ci-type-label">' + esc(str('type_' + t)) + '</span>' + hint + '</span>' +
        '</label>';
    }).join('');

    function field(id, extra, labelKey, hintKey) {
      var hint = hintKey && str(hintKey);
      var desc = 'etf-ci-' + id + '-err' + (hint ? ' etf-ci-' + id + '-hint' : '');
      return '<div class="etf-ci-field" data-ci-field="' + id + '">' +
        '<label class="etf-ci-label" for="etf-ci-' + id + '" data-ci-label="' + id + '">' + esc(str(labelKey)) + '</label>' +
        '<input class="etf-ci-input" id="etf-ci-' + id + '" name="' + id + '" aria-describedby="' + desc + '" ' + extra + '>' +
        (hint ? '<p class="etf-ci-hint" id="etf-ci-' + id + '-hint">' + esc(hint) + '</p>' : '') +
        '<p class="etf-ci-err" id="etf-ci-' + id + '-err" aria-live="polite"></p>' +
        '</div>';
    }

    modal.innerHTML =
      '<div class="etf-ci-backdrop" data-ci-close></div>' +
      '<div class="etf-ci-dialog" role="dialog" aria-modal="true" aria-labelledby="etf-ci-title" tabindex="-1">' +
        '<div class="etf-ci-head">' +
          '<h2 class="etf-ci-title" id="etf-ci-title">' + esc(str('title')) + '</h2>' +
          '<button type="button" class="etf-ci-x" data-ci-close aria-label="' + esc(str('close')) + '">' + ICON_CLOSE + '</button>' +
        '</div>' +
        '<form class="etf-ci-body" id="etf-ci-form" novalidate>' +
          '<fieldset class="etf-ci-types"><legend class="etf-ci-label">' + esc(str('company_type')) + '</legend>' +
            '<div class="etf-ci-type-grid">' + typeOpts + '</div></fieldset>' +
          field('name', 'type="text" autocomplete="organization" maxlength="200" required', 'company_name') +
          field('tckn', 'type="text" inputmode="numeric" autocomplete="off" maxlength="11" required', 'tckn', 'tckn_hint') +
          field('vkn', 'type="text" inputmode="numeric" autocomplete="off" maxlength="10" required', 'vkn') +
          field('office', 'type="text" autocomplete="off" maxlength="120" required', 'tax_office') +
          '<div class="etf-ci-field" data-ci-field="email">' +
            '<label class="etf-ci-label" for="etf-ci-email">' + esc(str('email')) +
              ' <span class="etf-ci-optional">' + esc(str('optional')) + '</span></label>' +
            '<input class="etf-ci-input" id="etf-ci-email" name="email" type="email" inputmode="email" autocomplete="email" maxlength="254" aria-describedby="etf-ci-email-err">' +
            '<p class="etf-ci-err" id="etf-ci-email-err" aria-live="polite"></p>' +
          '</div>' +
          (str('info_html') ? '<div class="etf-ci-note">' + ICON_INFO + '<div>' + str('info_html') + '</div></div>' : '') +
          (str('privacy_html') ? '<p class="etf-ci-privacy">' + str('privacy_html') + '</p>' : '') +
          '<p class="etf-ci-formerr" role="alert"></p>' +
        '</form>' +
        '<div class="etf-ci-foot">' +
          '<button type="button" class="etf-ci-btn etf-ci-btn--ghost" data-ci-close>' + esc(str('cancel')) + '</button>' +
          '<button type="submit" form="etf-ci-form" class="etf-ci-btn etf-ci-btn--primary" data-ci-save disabled>' + esc(str('save')) + '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    ui.dialog = modal.querySelector('.etf-ci-dialog');
    ui.form = modal.querySelector('form');
    ui.save = modal.querySelector('[data-ci-save]');
    ui.formErr = modal.querySelector('.etf-ci-formerr');
    ui.nameLabel = modal.querySelector('[data-ci-label="name"]');
    ui.inputs = {
      name: modal.querySelector('#etf-ci-name'),
      tckn: modal.querySelector('#etf-ci-tckn'),
      vkn: modal.querySelector('#etf-ci-vkn'),
      office: modal.querySelector('#etf-ci-office'),
      email: modal.querySelector('#etf-ci-email')
    };

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ci-close]')) close();
    });

    modal.querySelectorAll('input[name="etf-ci-type"]').forEach(function (r) {
      r.addEventListener('change', function () {
        /* Tur degisince numara TCKN <-> VKN olur; eski deger diger
           algoritmaya gore gecersiz kalacagi icin alan temizlenir. */
        var wasSahis = form.type === 'sahis';
        form.type = r.value;
        if (wasSahis !== (form.type === 'sahis')) {
          form.tckn = form.vkn = '';
          ui.inputs.tckn.value = ui.inputs.vkn.value = '';
          delete touched.tckn;
          delete touched.vkn;
        }
        sync();
      });
    });

    Object.keys(ui.inputs).forEach(function (k) {
      var el = ui.inputs[k];
      el.addEventListener('input', function () {
        if (k === 'tckn' || k === 'vkn') {
          var clean = digits(el.value).slice(0, k === 'tckn' ? 11 : 10);
          if (clean !== el.value) el.value = clean;
          /* Tam uzunluga ulasinca hatayi hemen goster — kullanici bitti demektir. */
          if (clean.length === (k === 'tckn' ? 11 : 10)) touched[k] = true;
        }
        form[k] = el.value;
        sync();
      });
      el.addEventListener('blur', function () { touched[k] = true; sync(); });
    });

    ui.form.addEventListener('submit', function (e) { e.preventDefault(); save(); });

    /* Esc: yalnizca popup'i kapat. Yayilmayi durdurmazsak cekmecenin
       `keydown.escape.window` dinleyicisi cekmeceyi de kapatir. */
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        trapTab(e);
      }
    });

    /* Klavye acikken alan gorunur kalsin. */
    ui.dialog.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('etf-ci-input')) {
        setTimeout(function () {
          try { t.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {}
        }, 250);
      }
    });
  }

  function focusables() {
    return Array.prototype.filter.call(
      ui.dialog.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) {
        if (el.disabled || el.type === 'hidden') return false;
        if (el.type === 'radio' && !el.checked) return false;
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      }
    );
  }

  function trapTab(e) {
    var f = focusables();
    if (!f.length) { e.preventDefault(); ui.dialog.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === ui.dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  /* Mobilde klavye acilinca gorunur alan kuculur; alttan acilan sayfayi
     klavyenin ustune oturt ve yuksekligini gorunur alana sigdir. */
  function onViewport() {
    var vv = window.visualViewport;
    if (!vv || !modal) return;
    var kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    modal.style.setProperty('--etf-ci-kb', kb + 'px');
    modal.style.setProperty('--etf-ci-vvh', vv.height + 'px');
  }

  function errors() {
    var e = {};
    var sahis = form.type === 'sahis';
    if (!(form.name || '').trim()) e.name = str('err_required');
    if (sahis) {
      var tc = digits(form.tckn);
      if (!tc) e.tckn = str('err_required');
      else if (!isTckn(tc)) e.tckn = str('err_tckn');
    } else {
      var vk = digits(form.vkn);
      if (!vk) e.vkn = str('err_required');
      else if (!isVkn(vk)) e.vkn = str('err_vkn');
    }
    if (!(form.office || '').trim()) e.office = str('err_required');
    var em = (form.email || '').trim();
    if (em && !isEmail(em)) e.email = str('err_email');
    if (!form.type) e.type = str('err_required');
    return e;
  }

  function sync() {
    var sahis = form.type === 'sahis';
    modal.querySelector('[data-ci-field="tckn"]').hidden = !sahis;
    modal.querySelector('[data-ci-field="vkn"]').hidden = sahis;
    ui.nameLabel.textContent = str(sahis ? 'name_person' : 'company_name');

    var e = errors();
    ['name', 'tckn', 'vkn', 'office', 'email'].forEach(function (k) {
      var show = touched[k] && e[k];
      var input = ui.inputs[k];
      var err = modal.querySelector('#etf-ci-' + k + '-err');
      err.textContent = show ? e[k] : '';
      input.setAttribute('aria-invalid', show ? 'true' : 'false');
    });
    ui.save.disabled = busy || Object.keys(e).length > 0;
  }

  function fill() {
    var a = store.attrs || pick({});
    var set = isSet(a);
    var type = set ? (a.sirket_turu === 'sahis' ? 'sahis' : 'tuzel') : (form.type || 'tuzel');
    form = {
      type: type,
      name: set ? a.firma_unvani : '',
      tckn: set && type === 'sahis' ? digits(a.vergi_no || a.tc_no) : '',
      vkn: set && type !== 'sahis' ? digits(a.vergi_no) : '',
      office: set ? a.vergi_dairesi : '',
      email: set ? a.efatura_eposta : ''
    };
    touched = {};
    /* Kayitli bilgi yeniden aciliyorsa hatalari hemen goster: gecersiz
       bir deger (elle degistirilmis attribute) sessizce kalmasin. */
    if (set) ['name', 'tckn', 'vkn', 'office', 'email'].forEach(function (k) { touched[k] = true; });

    modal.querySelectorAll('input[name="etf-ci-type"]').forEach(function (r) { r.checked = r.value === type; });
    Object.keys(ui.inputs).forEach(function (k) { ui.inputs[k].value = form[k] || ''; });
    ui.formErr.textContent = '';
  }

  /* look="card" (cart-main-02): popup'in ana butonu bulundugu bolumun sema
     butonunu ve koselerini alir; boylece "Kaydet" "Devam et" ile ayni gorunur.
     look yoksa degiskenler temizlenir → --ga-cardbtn-* (eski davranis). */
  var LOOK_VARS = { '--etf-ci-btn': '--color-button', '--etf-ci-btn-fg': '--color-button-label', '--etf-ci-btn-radius': '--etf-ci-btn-radius' };

  function applyLook(host) {
    var look = (host && host.dataset.look) || '';
    var cs = look ? getComputedStyle(host) : null;
    if (look) modal.setAttribute('data-look', look);
    else modal.removeAttribute('data-look');
    Object.keys(LOOK_VARS).forEach(function (k) {
      var v = cs ? cs.getPropertyValue(LOOK_VARS[k]).trim() : '';
      if (v) modal.style.setProperty(k, v);
      else modal.style.removeProperty(k);
    });
  }

  function open(host) {
    buildModal();
    applyLook(host);
    opener = host || null;
    busy = false;
    fill();
    sync();
    modal.hidden = false;
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
      onViewport();
    }
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      /* Ilk odak secili sirket turunde: metin alanina odaklanmak mobilde
         klavyeyi hemen acip sayfanin yarisini kapatirdi. */
      var r = modal.querySelector('input[name="etf-ci-type"]:checked');
      (r || ui.dialog).focus({ preventScroll: true });
    });
    /* Veri henuz dogrulanmadiysa arka planda cek, gelince doldur (kullanici
       yazmaya baslamadiysa). */
    if (!store.verified) {
      var p = verify();
      if (p) p.then(function () {
        if (!modal.hidden && !Object.keys(touched).length && isSet(store.attrs)) { fill(); sync(); }
      });
    }
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.style.overflow = prevOverflow;
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', onViewport);
      window.visualViewport.removeEventListener('scroll', onViewport);
    }
    restoreFocus();
  }

  function restoreFocus() {
    var h = opener;
    opener = null;
    if (!h || !h.isConnected) return;
    var target = h.querySelector('[data-ci-edit]') || h.querySelector('[data-ci-open]');
    if (target) target.focus({ preventScroll: true });
  }

  function save() {
    if (busy) return;
    ['name', 'tckn', 'vkn', 'office', 'email'].forEach(function (k) { touched[k] = true; });
    sync();
    if (Object.keys(errors()).length) return;

    var sahis = form.type === 'sahis';
    var id = sahis ? digits(form.tckn) : digits(form.vkn);
    var attrs = {
      fatura_tipi: 'kurumsal',
      sirket_turu: sahis ? 'sahis' : CORP_VALUE,
      firma_unvani: form.name.trim(),
      vergi_no: id,
      vergi_dairesi: form.office.trim(),
      tc_no: '',
      efatura_eposta: (form.email || '').trim()
    };

    busy = true;
    ui.save.textContent = str('saving');
    ui.formErr.textContent = '';
    sync();

    writeAttrs(attrs).then(function () {
      busy = false;
      ui.save.textContent = str('save');
      close();
    }).catch(function () {
      busy = false;
      ui.save.textContent = str('save');
      ui.formErr.textContent = str('err_save');
      sync();
    });
  }

  function remove(host) {
    var btn = host.querySelector('[data-ci-remove]');
    if (btn) btn.disabled = true;
    writeAttrs(emptyAttrs()).then(function () {
      var t = host.querySelector('[data-ci-open]');
      if (t) t.focus({ preventScroll: true });
    }).catch(function () {
      if (btn) btn.disabled = false;
    });
  }

  /* ---------- Sepetteki bilesen ---------- */

  class EtfCorporateInvoice extends HTMLElement {
    connectedCallback() {
      if (!store.attrs && this.dataset.state) {
        try { store.attrs = pick(JSON.parse(this.dataset.state)); } catch (_) {}
      }
      if (store.hosts.indexOf(this) === -1) store.hosts.push(this);
      if (!this._bound) {
        this._bound = true;
        this.addEventListener('click', this.onClick.bind(this));
      }
      this.render();
      verify();
    }

    disconnectedCallback() {
      var i = store.hosts.indexOf(this);
      if (i > -1) store.hosts.splice(i, 1);
    }

    onClick(e) {
      if (e.target.closest('[data-ci-open], [data-ci-edit]')) { e.preventDefault(); open(this); }
      else if (e.target.closest('[data-ci-remove]')) { e.preventDefault(); remove(this); }
    }

    render() {
      var a = store.attrs;
      if (isSet(a)) {
        var sahis = a.sirket_turu === 'sahis';
        var idLabel = str(sahis ? 'id_tckn' : 'id_vkn');
        this.innerHTML =
          '<div class="etf-ci-card">' +
            '<span class="etf-ci-card-icon">' + ICON_DOC + '</span>' +
            '<div class="etf-ci-card-body">' +
              '<p class="etf-ci-card-main"><strong>' + esc(str('summary_label')) + '<span class="etf-ci-colon">:</span></strong> ' +
                '<span class="etf-ci-card-name">' + esc(a.firma_unvani) + '</span>' +
                ' <span class="etf-ci-sep" aria-hidden="true">·</span> ' +
                '<span class="etf-ci-card-id">' + esc(idLabel) + ' ' + esc(a.vergi_no) + '</span></p>' +
              '<p class="etf-ci-card-actions">' +
                '<button type="button" class="etf-ci-link" data-ci-edit aria-haspopup="dialog">' + esc(str('edit')) + '</button>' +
                ' <span class="etf-ci-sep" aria-hidden="true">·</span> ' +
                '<button type="button" class="etf-ci-link" data-ci-remove>' + esc(str('remove')) + '</button>' +
              '</p>' +
              (str('info_html') ? '<div class="etf-ci-card-note">' + str('info_html') + '</div>' : '') +
            '</div>' +
          '</div>';
      } else {
        this.innerHTML =
          '<button type="button" class="etf-ci-trigger" data-ci-open aria-haspopup="dialog">' +
            '<span class="etf-ci-card-icon">' + ICON_DOC + '</span>' +
            '<span class="etf-ci-trigger-label">' + esc(str('trigger')) + '</span>' +
            '<span class="etf-ci-trigger-chev">' + ICON_CHEVRON + '</span>' +
          '</button>';
      }
    }
  }

  if (!customElements.get('etf-corporate-invoice')) {
    customElements.define('etf-corporate-invoice', EtfCorporateInvoice);
  }

  /* Test/entegrasyon icin disari acik — backend ile ayni algoritma mi diye
     konsoldan denenebilir. */
  window.etfCorporateInvoice = { isTckn: isTckn, isVkn: isVkn, open: function () { open(null); } };
})();
